import api from '@/api'
import { getStorageSync } from '@/utils/uni-app'
export const squareKinds = [
  { value: 'parts', label: '取件表结果', category: 'parts' },
  { value: 'board', label: '灵感画板', category: 'boards' },
  { value: 'manual', label: '模型说明书', category: 'gallery' },
  { value: 'line', label: '线稿上色 · 线稿', category: 'gallery' },
  { value: 'color', label: '线稿上色 · 上色图', category: 'gallery' },
  { value: 'preview', label: '线稿上色 · 预览图', category: 'gallery' },
  { value: 'extreme', label: '极致分色效果图', category: 'gallery' },
  { value: 'generated', label: 'AI 生图', category: 'gallery' },
  { value: 'article', label: '我的图文', category: 'gallery' }
]
export const kindLabel = kind => squareKinds.find(item => item.value === kind)?.label || '创作分享'
export async function squareRequest(method, path, data, params) {
  const res = await api({ method, url: '/liner/square/' + path, data, params, timeout: 30000 })
  if (Number(res.code) !== 200) throw new Error(res.msg || '操作失败，请重试')
  return res.data
}
export async function squareUpload(file) {
  if (file.size > 20 * 1024 * 1024) throw new Error('每个附件不能超过20MB')
  const form = new FormData(); form.append('file', file)
  const res = await api.upload('/liner/square/assets', form)
  if (Number(res.code) !== 200) throw new Error(res.msg || '上传失败')
  return res.data.asset
}
export function squareLogin(router, redirect) { return router.push({ path: '/login', query: { redirect } }) }
export function partsRows(parts = []) {
  const groups = new Map()
  for (const item of parts) {
    const part = String(item.type || '').trim() || '未分类'
    const content = String(item.content || '').trim()
    const match = content.match(/^([^(]+)\s*\((.*)\)$/)
    const type = (match ? match[1] : content).replace(/-/g, '').trim() || '-'
    const suffix = match ? match[2].trim() : ''
    const key = part + '|' + type
    if (!groups.has(key)) groups.set(key, { part, type, suffixes: new Map() })
    const group = groups.get(key)
    if (suffix) group.suffixes.set(suffix, (group.suffixes.get(suffix) || 0) + (parseInt(item.num) || 0))
  }
  return [...groups.values()].map(row => ({
    part: row.part, type: row.type,
    content: [...row.suffixes.entries()].sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true })).map(([key, count]) => count > 1 ? key + '*' + count : key).join(', ') || (row.type === '-' ? '无编号' : '')
  })).sort((a,b) => a.part.localeCompare(b.part) || a.type.localeCompare(b.type))
}

export async function hydrateSquareReactions(posts) {
 const token=getStorageSync('token')
 if (!posts.length || !token) return posts
 try {
  const data = await squareRequest('get','reactions',undefined,{ids:posts.map(p=>p.id).join(',')})
  if(getStorageSync('token')!==token)return posts
  const states = new Map((data.list || []).map(row=>[row.id,row]))
  return posts.map(post=>states.has(post.id)?{...post,...states.get(post.id),_reaction_ready:true}:post)
 } catch (_) { return posts } // Each action retries its own state before changing it.
}
